import { __generator } from "tslib";
import { call, all, put, select } from 'redux-saga/effects';
import { request } from '../../xhr';
import { actions as StreamActions } from '../../Stream';
import { getCurrentStreamId, getCurrentGallection, getCurrentSubfolder, } from '../selectors';
import { deselectMulti } from '../actions';
import updateGallectionSize from './updateGallectionSize';
function removeDeviationsHandler(action) {
    var deviationIds, _a, streamId, currentGallection, currentSubfolder, currentFolderId;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                deviationIds = action.payload;
                return [4 /*yield*/, select(function (state) { return ({
                        streamId: getCurrentStreamId(state),
                        currentGallection: getCurrentGallection(state),
                        currentSubfolder: getCurrentSubfolder(state),
                    }); })];
            case 1:
                _a = _b.sent(), streamId = _a.streamId, currentGallection = _a.currentGallection, currentSubfolder = _a.currentSubfolder;
                return [4 /*yield*/, all([
                        put(StreamActions.deleteItems({ streamId: streamId, items: deviationIds })),
                        put(deselectMulti(deviationIds)),
                    ])];
            case 2:
                _b.sent();
                if (!currentGallection) {
                    return [2 /*return*/];
                }
                currentFolderId = currentSubfolder
                    ? currentSubfolder.folderId
                    : currentGallection.folderId;
                return [4 /*yield*/, call(updateGallectionSize, currentFolderId, -deviationIds.length)];
            case 3:
                _b.sent();
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: 'gallection/folders/remove_deviations',
                        data: {
                            type: currentGallection.type,
                            folderid: currentFolderId,
                            deviationids: deviationIds,
                        },
                    })];
            case 4:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
export default removeDeviationsHandler;
//# sourceMappingURL=removeDeviations.js.map